import { render, staticRenderFns } from "./activityPropDetails.vue?vue&type=template&id=27e785c0&scoped=true&"
import script from "./activityPropDetails.vue?vue&type=script&lang=js&"
export * from "./activityPropDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e785c0",
  null
  
)

export default component.exports